import { Middleware } from "redux";
import { AppState } from "../redux/AppTypes";
import {
  TeamAction as BaseAction,
  FETCH_TEAMS as FETCH,
  LOAD_TEAMS as LOAD,
  LoadTeamsAction as LoadAction,
  REMOVE_TEAM as REMOVE,
  REMOVE_TEAM_LOCAL,
  PERSIST_TEAM as PERSIST,
  PersistTeamResult,
  UPSERT_TEAM,
} from "./TeamsTypes";
import service from "./TeamService";

const fetchMiddleware: Middleware<{}, AppState> = (store) => (next) => async (
  action: BaseAction
) => {
  const result = next(action);
  if (action.type === FETCH) {
    const page = action.paginated
      ? await service.fetchPage({
          limit: action.limit,
          nextToken: action.nextToken,
        })
      : undefined;
    const items = page ? page.items : await service.fetch();
    const load: LoadAction = {
      type: LOAD,
      append: action.append,
      items,
      loadedAll: page ? !page.nextToken : true,
      nextToken: page?.nextToken,
    };
    store.dispatch(load);
    return items;
  } else {
    return result;
  }
};

const deleteMiddleware: Middleware<{}, AppState> = (store) => (next) => async (
  action: BaseAction
) => {
  const result = next(action);
  if (action.type === REMOVE) {
    await service.delete(action.id);
    store.dispatch({ type: REMOVE_TEAM_LOCAL, id: action.id });
    return action.id;
  } else {
    return result;
  }
};

const persistMiddleware: Middleware<{}, AppState> = (store) => (next) => async (
  action: BaseAction
) => {
  const result = next(action);
  if (action.type === PERSIST) {
    const saveResult = await service.persist(action.item);
    const item = normalizePersistResult(saveResult);
    store.dispatch({ type: UPSERT_TEAM, item });
    return saveResult;
  } else {
    return result;
  }
};

function normalizePersistResult(result: PersistTeamResult | any): any {
  return result?.item || result;
}

const middlewares = [
  fetchMiddleware,
  deleteMiddleware,
  persistMiddleware,
];
export default middlewares;
